export enum ROLES {
  TCO_FLEET_ADMIN = 'tco_fleet_admin',

  ORGANISATION_ADMIN = 'organisation_admin',

  FLEET_MANAGER = 'fleet_manager',

  EMPLOYEE = 'employee',
}
